import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { CustomModal, InputText, CustomCheckbox, Btn } from '../../../../components'
import * as EquipeHttp from '../../../../services/api/https/picking/picking-team.http'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE_TEAM: 'Salvando equipe',
  SUCCESS: 'Equipe salva com sucesso',
}

const INITIAL_STATE = {
  equipe: {
    id: 0,
    name: '',
    tp_id: 0,
    actived: true,
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

function ModalEquipeSeparacao({ dispatch, data, show, onModalSave, onModalClose }) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    setState(prevState => ({ ...prevState, equipe: { ...data } }))
  }, [data])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SAVE_TEAM:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        saveEquipe(state.equipe)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave(state.equipe)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  const saveEquipe = equipe => {
    EquipeHttp.saveEquipe(equipe)
      .then(equipe =>
        setState(prevState => ({
          ...prevState,
          equipe: equipe,
          loadingMessage: LOAD_MESSAGE.SUCCESS,
        })),
      )
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const onFormContentChange = (name, value) => {
    setState(prevState => {
      prevState.equipe[name] = value
      return { ...prevState }
    })
  }

  const onBtnSalvarClicked = () => {
    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_TEAM }))
  }

  return (
    <CustomModal header="Equipe de Separação" isVisible={show} onClose={onModalClose}>
      <form className="p-grid">
        <div className="p-col-8">
          <InputText
            label="Equipe :"
            marginTop={10}
            value={state.equipe.name}
            onChange={value => onFormContentChange('name', value)}
          />
        </div>
        <div className="p-col-4" style={{ paddingTop: 43 }}>
          <CustomCheckbox
            onChange={value => onFormContentChange('actived', value)}
            checked={state.equipe.actived}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}
export default connect()(ModalEquipeSeparacao)
